export interface LoadingTimeoutResult {
  timedOut: boolean;
}

export function releaseLoadingAfterTimeout(
  promise: Promise<void>,
  ms: number,
): Promise<LoadingTimeoutResult> {
  let timedOut = false;
  let timeoutId: ReturnType<typeof setTimeout> | null = null;

  const timeoutPromise = new Promise<LoadingTimeoutResult>((resolve) => {
    timeoutId = setTimeout(() => {
      timedOut = true;
      console.warn('[org] fetch is taking longer than expected', {
        timeoutMs: ms,
      });
      resolve({ timedOut: true });
    }, ms);
  });

  void promise.catch((error) => {
    if (timedOut) {
      console.error('[org] fetch failed after timeout', error);
    }
  });

  return Promise.race([
    promise.then(() => ({ timedOut: false })),
    timeoutPromise,
  ]).finally(() => {
    if (timeoutId !== null) {
      clearTimeout(timeoutId);
    }
  });
}
